import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    // currentPage: NavPaths.dashboard,
    shouldMarginUpdate: false,
};
export const nonPersistSlice = createSlice({
    name: "non-persist",
    initialState: initialState,
    reducers: {
        // setCurrentPage(state, action: PayloadAction<SliceState["currentPage"]>) {
        //   state.currentPage = action.payload;
        // },
        marginUpdate(state, action) {
            state.shouldMarginUpdate = action.payload;
        },
    },
});
export const { marginUpdate } = nonPersistSlice.actions;
export default nonPersistSlice.reducer;
